<template>
  <div class="offering">
    <h2 class="is-size-4-touch">Employee Leasing & Staffing</h2>
    <p>
      Availability of organised labour is one of the biggest areas of concern in
      India. Athena ensures such availability of well trained and energetic
      labour force. Amongst multiple benefits are:
    </p>
    <ul>
      <li>Saves on hiring and replacement cost.</li>
      <li>
        Hire when you need: this saves further on cost as you can retain those
        you feel are best.
      </li>
      <li>Optimizes headcount and keeps your organization lean & thin.</li>
      <li>Total statutory compliance.</li>
      <li>Reduces cost of permanent liability.</li>
      <li>Staff with requisite skills available at short notice.</li>
      <li>Ready access to pool of trained & experienced personnel.</li>
      <li>
        No advertisements or interviews, thus saving time and reduces cost.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "OfferingELS",
  props: {},
};
</script>
